// Module
var code = `<section class="carousel" ng-if="show"><div class="page_header"><h3 ng-bind="title"></h3><a class="carousel-header-link" data-carousel-header-link="{{title}}" data-isource="{{isource}}" gi-track="track.landing.seeMoreCarouselClicked" ng-bind="viewAllText" ng-href="{{searchHref}}" target="{{target}}"></a></div><gi-carousel></gi-carousel></section> `;
// Exports
var _module_exports =code;;
var path = 'carousels/search.html.slim';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;